import { Component, OnDestroy } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { FilterService } from "../../../_shared/services";
import { WidgetFilterData } from "../../../_shared/models";

@Component({
  standalone: true,
  imports: [],
  template: ''
})
export abstract class BaseWidgetComponent implements OnDestroy {
  title: string = '';
  value: number = 0;
  isLoading: boolean = false;
  percentageDifference: number;
  difference: number;
  totalCost: number = 0;
  percentageDifferenceEnabled: boolean = true;
  widgetFilter: WidgetFilterData = {} as WidgetFilterData;
  widgetFilterSubscription: Subscription;
  widgetDisabled: boolean;
  protected cancelSubject = new Subject<void>();

  constructor(protected filterService: FilterService) {
    this.widgetFilterSubscription = this.filterService.filterUpdated$.subscribe(async (filter) => {
      if (Object.values(filter).every(x => x === null) || filter === null) {
        return;
      }

      this.widgetFilter = filter;
      await this.onFilterChangeAsync();
    });
  }

  ngOnDestroy(): void {
    this.widgetFilterSubscription && this.widgetFilterSubscription.unsubscribe();
    this.cancelSubject.next();
    this.onDestroy();
  }

  protected abstract onFilterChangeAsync(): Promise<void>;

  public abstract formatValue(value: number): string;

  // override in the concrete class if needed
  protected onDestroy = (): void => { };
}